<template>
    <SOSlotModal  
        modal-title="Pindah ke dashboard"
        :modal-id="id"
        :no-padding="true"
        @close="close()"
    >
        <template v-slot:modal-body>
            <div class="p-4">
                <p class="f-16 m-d-4">
                    Anda Menggunakan versi terbaru dari aplikasi Smart Owner. versi ini masih dalam pengembangan, bantu kami lebih baik. Informasi lebih lanjut hubungi <a class="f-c-blue" href="https://s.id/smartcare" target="_blank">s.id/smartcare.</a>  
                    <br><br>
                    Telah didukung oleh beberapa fitur lebih lengkap.
                </p>
                <div class="f-c-midgrey f-14">
                    <p class="m-d-0"> List fitur tambahan yang bisa dicoba : </p>
                    <ul id="features">
                        <li>Fitur Level Akses</li>
                        <li>Fitur Snap WhatsApp</li>
                        <li>Fitur Inventori</li>
                        <li>Fitur Promo</li>
                    </ul>
                </div>
            </div>
        </template>
        <template v-slot:modal-footer>
            <div id="button" class="px-4 pb-2">
                <SOButton
                    text="Gunakan smartlink versi dashboard sekarang"
                    :primary="true"
                    :full="true"
                    :loading="isLoading"
                    :disable="isLoading"
                    @action="confirm()"
                />
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInformation from "@/so-components/global/ui/SOInformation.vue";
import conn from '../../../store/utils/connection'
import metaApi from '../../../store/utils/api-route/metaAPI'

export default {
    name: "SOModalBeta",
    components: {
        SOSlotModal,
        SOButton,
        SOInformation,
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        closable: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        isOpen() {
            return this.value;
        },
    },
    data () {
        return {
            id:"confirm-modal",
            requestChange: null,
            resolve: null,
            isLoading: false,
        }
    },
    methods: {
        open() {
            $("#" + this.id).modal("show");
            $("#" + this.id).css('z-index', '99999999')
        },
        close() {
            if(!this.closable) return;
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("input", false);
                this.$emit("close");
            }, 500);
        },
        async confirm() {
            this.isLoading = true
            try {
                const res =  await conn.post(metaApi.new_owner_beta, {enable: 1,})
                if (res.data.status) {
                    console.log(res);
                    if (res.data.data.enable === 1) this.switchNewSmartowner();
                }
            } catch (error) {
                console.log(error)
            }
            this.isLoading = false
        }
    },
    watch: {
        isOpen: {
            handler: function (val) {
                if (val) {
                    this.open();
                } else {
                    this.close();
                }
            },
            deep: true,
            immediate: true
        },
    }
}
</script>

<style scoped>
#button >>> .btn-outline-danger{
    margin-bottom: 1rem
}
#features{
    padding-left: 1.5rem;
}
</style>